import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "person-link",
  templateUrl: "./person-link.html",
  standalone: false,
})
export class PersonLink implements OnInit {
  @Input() user: string;
  @Input() icon: string = "person";
  @Input() userCai: string;

  ngOnInit() {
    console.log("init person link");
  }

  openWindow(event: Event) {
    console.log(event);
    return false;
  }
}
